/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as appRouteImport } from "./routes/_app"
import { Route as appDotindexRouteImport } from "./routes/_app.index"
import { Route as loginDotresetRouteImport } from "./routes/login.reset"
import { Route as DotDotPagesMpGraphsRouteRouteImport } from "./pages/mp-graphs/route"
import { Route as DotDotPagesMpEventsRouteRouteImport } from "./pages/mp-events/route"
import { Route as DotDotPagesHubHealthRouteRouteImport } from "./pages/hub-health/route"
import { Route as DotDotPagesExamplePageRouteRouteImport } from "./pages/example-page/route"
import { Route as DotDotPagesCmeFeedbackRouteRouteImport } from "./pages/cme-feedback/route"

const appRoute = appRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const appDotindexRoute = appDotindexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => appRoute,
} as any)
const loginDotresetRoute = loginDotresetRouteImport.update({
  id: "/login/reset",
  path: "/login/reset",
  getParentRoute: () => rootRouteImport,
} as any)
const DotDotPagesMpGraphsRouteRoute =
  DotDotPagesMpGraphsRouteRouteImport.update({
    id: "/mp-graphs",
    path: "/mp-graphs",
    getParentRoute: () => appRoute,
  } as any)
const DotDotPagesMpEventsRouteRoute =
  DotDotPagesMpEventsRouteRouteImport.update({
    id: "/mp-events",
    path: "/mp-events",
    getParentRoute: () => appRoute,
  } as any)
const DotDotPagesHubHealthRouteRoute =
  DotDotPagesHubHealthRouteRouteImport.update({
    id: "/hub-health",
    path: "/hub-health",
    getParentRoute: () => appRoute,
  } as any)
const DotDotPagesExamplePageRouteRoute =
  DotDotPagesExamplePageRouteRouteImport.update({
    id: "/example-page",
    path: "/example-page",
    getParentRoute: () => appRoute,
  } as any)
const DotDotPagesCmeFeedbackRouteRoute =
  DotDotPagesCmeFeedbackRouteRouteImport.update({
    id: "/cme-feedback",
    path: "/cme-feedback",
    getParentRoute: () => appRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/cme-feedback": typeof DotDotPagesCmeFeedbackRouteRoute
  "/example-page": typeof DotDotPagesExamplePageRouteRoute
  "/hub-health": typeof DotDotPagesHubHealthRouteRoute
  "/mp-events": typeof DotDotPagesMpEventsRouteRoute
  "/mp-graphs": typeof DotDotPagesMpGraphsRouteRoute
  "/login/reset": typeof loginDotresetRoute
  "/": typeof appDotindexRoute
}
export interface FileRoutesByTo {
  "/cme-feedback": typeof DotDotPagesCmeFeedbackRouteRoute
  "/example-page": typeof DotDotPagesExamplePageRouteRoute
  "/hub-health": typeof DotDotPagesHubHealthRouteRoute
  "/mp-events": typeof DotDotPagesMpEventsRouteRoute
  "/mp-graphs": typeof DotDotPagesMpGraphsRouteRoute
  "/login/reset": typeof loginDotresetRoute
  "/": typeof appDotindexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_app": typeof appRouteWithChildren
  "/_app/cme-feedback": typeof DotDotPagesCmeFeedbackRouteRoute
  "/_app/example-page": typeof DotDotPagesExamplePageRouteRoute
  "/_app/hub-health": typeof DotDotPagesHubHealthRouteRoute
  "/_app/mp-events": typeof DotDotPagesMpEventsRouteRoute
  "/_app/mp-graphs": typeof DotDotPagesMpGraphsRouteRoute
  "/login/reset": typeof loginDotresetRoute
  "/_app/": typeof appDotindexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/cme-feedback"
    | "/example-page"
    | "/hub-health"
    | "/mp-events"
    | "/mp-graphs"
    | "/login/reset"
    | "/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/cme-feedback"
    | "/example-page"
    | "/hub-health"
    | "/mp-events"
    | "/mp-graphs"
    | "/login/reset"
    | "/"
  id:
    | "__root__"
    | "/_app"
    | "/_app/cme-feedback"
    | "/_app/example-page"
    | "/_app/hub-health"
    | "/_app/mp-events"
    | "/_app/mp-graphs"
    | "/login/reset"
    | "/_app/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  appRoute: typeof appRouteWithChildren
  loginDotresetRoute: typeof loginDotresetRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof appRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/": {
      id: "/_app/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof appDotindexRouteImport
      parentRoute: typeof appRoute
    }
    "/login/reset": {
      id: "/login/reset"
      path: "/login/reset"
      fullPath: "/login/reset"
      preLoaderRoute: typeof loginDotresetRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/mp-graphs": {
      id: "/_app/mp-graphs"
      path: "/mp-graphs"
      fullPath: "/mp-graphs"
      preLoaderRoute: typeof DotDotPagesMpGraphsRouteRouteImport
      parentRoute: typeof appRoute
    }
    "/_app/mp-events": {
      id: "/_app/mp-events"
      path: "/mp-events"
      fullPath: "/mp-events"
      preLoaderRoute: typeof DotDotPagesMpEventsRouteRouteImport
      parentRoute: typeof appRoute
    }
    "/_app/hub-health": {
      id: "/_app/hub-health"
      path: "/hub-health"
      fullPath: "/hub-health"
      preLoaderRoute: typeof DotDotPagesHubHealthRouteRouteImport
      parentRoute: typeof appRoute
    }
    "/_app/example-page": {
      id: "/_app/example-page"
      path: "/example-page"
      fullPath: "/example-page"
      preLoaderRoute: typeof DotDotPagesExamplePageRouteRouteImport
      parentRoute: typeof appRoute
    }
    "/_app/cme-feedback": {
      id: "/_app/cme-feedback"
      path: "/cme-feedback"
      fullPath: "/cme-feedback"
      preLoaderRoute: typeof DotDotPagesCmeFeedbackRouteRouteImport
      parentRoute: typeof appRoute
    }
  }
}

interface appRouteChildren {
  DotDotPagesCmeFeedbackRouteRoute: typeof DotDotPagesCmeFeedbackRouteRoute
  DotDotPagesExamplePageRouteRoute: typeof DotDotPagesExamplePageRouteRoute
  DotDotPagesHubHealthRouteRoute: typeof DotDotPagesHubHealthRouteRoute
  DotDotPagesMpEventsRouteRoute: typeof DotDotPagesMpEventsRouteRoute
  DotDotPagesMpGraphsRouteRoute: typeof DotDotPagesMpGraphsRouteRoute
  appDotindexRoute: typeof appDotindexRoute
}

const appRouteChildren: appRouteChildren = {
  DotDotPagesCmeFeedbackRouteRoute: DotDotPagesCmeFeedbackRouteRoute,
  DotDotPagesExamplePageRouteRoute: DotDotPagesExamplePageRouteRoute,
  DotDotPagesHubHealthRouteRoute: DotDotPagesHubHealthRouteRoute,
  DotDotPagesMpEventsRouteRoute: DotDotPagesMpEventsRouteRoute,
  DotDotPagesMpGraphsRouteRoute: DotDotPagesMpGraphsRouteRoute,
  appDotindexRoute: appDotindexRoute,
}

const appRouteWithChildren = appRoute._addFileChildren(appRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  appRoute: appRouteWithChildren,
  loginDotresetRoute: loginDotresetRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
